import { useEffect, useState } from "react"
import { getMarcaById, postMarca, patchMarca } from "../../services/MarcasServices"
import { MarcasFormContext } from "./MarcasContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const MarcasFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getMarcaByIdData(id)
    }, [])

    const getMarcaByIdData = async (id) => {
        let res = await getMarcaById(id)
        
        if (res) setReport(res)
    }

    const postMarcaData = async (body) => {
        const res = await postMarca(body)
        
        if (res) navigate("/marcas");
    }

    const patchMarcaData = async (id, body) => {
        const res = await patchMarca(id, body)

        if (res) navigate("/marcas");
    }


    return <MarcasFormContext.Provider value={{
        report,
        postMarcaData,
        patchMarcaData,
    }} >
        {children}
    </MarcasFormContext.Provider>
}